import React from 'react';

import CSnappingCarousel from '../pages/news/CSnappingCarousel';

interface Props {
  children: React.ReactNode;
  id: string;
  activeIndex?: number;
}

export default function LinkTabButtonWrapper(props: Props) {
  return (
    <CSnappingCarousel
      id={props.id}
      cardSpacerStyle={{ gap: '0.5rem' }}
      activeIndex={props.activeIndex}
      navigationStyle={'none'}
      propagateEdgeClicks
    >
      {React.Children.map(props.children, (child, index) => (
        <div key={index} className={'flex-shrink-0'}>
          {child}
        </div>
      ))}
    </CSnappingCarousel>
  );
}
